import { connect } from 'react-redux';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { Popconfirm, Tooltip, Input,Button } from 'antd';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import { MASTERTASK } from '../../../../../commons/api';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';
import localStorage from '../../../../../utils/localStorage';

import { getTaskList, deleteById } from '../../../Utils/FormCalls';
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';

const TaskList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  // const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  let config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['TaskName', 'Description'],
    firstTitle: 'TaskName',
    secondTitle: 'FirstName',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/TasksDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    _getDataSource();
  }, []);

  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile]);

  const _editRecord = async (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  // const _getUserList = async () => {
  //   const users = await getUsersList();
  //   setUserList(users);
  // };

  const _getDataSource = async () => {
    const tasks = await getTaskList('both');
    setDataSource(tasks);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <SearchOutlined
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 90, marginRight: 8, }}
        />
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && record[dataIndex] !== null
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const _deleteById = async (id) => {
    const siteId = localStorage.get('currentSite');
    const payload = {
      url: `${MASTERTASK.DELETE}?Id=${id}&SiteId=${siteId}`,
      method: 'POST'
    };
    await deleteById(payload);
    const tasks = await getTaskList('both');
    setDataSource(tasks);
  };

  const { translationCache } = props;
  const columns = [
    {
      title: translation(translationCache, constant.task),
      dataIndex: 'TaskName',
      key: 'TaskName',
      filter: true,
      ...getColumnSearchProps('TaskName')
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'TaskDescription',
      key: 'TaskDescription',
      ...getColumnSearchProps('TaskDescription')
    },
    // {
    //   title: translation(translationCache, constant.type),
    //   dataIndex: 'Type',
    //   key: 'Type'
    // },
    {
      title: translation(translationCache, constant.site),
      dataIndex: 'SiteName',
      key: 'SiteName',
      filter: true
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            disabled={record.Status === 'Inactive'}
            style={{ marginRight: '5px' }}
            onClick={() => _editRecord(record)}
          >
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(translationCache, constant.areYouSureThatYouWantToDeleteTheTask)}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.Id)}
            okText={translation(translationCache, constant.yes)}
            cancelText={translation(translationCache, constant.no)}
          >
            <Button>
              <Tooltip title={translation(translationCache, 'Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];
  config = {
    title: translation(translationCache, 'Tasks'),

    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',

    filterType: 'ByAttributeValue',
    attributeList: ['TaskName'],

    firstTitle: 'TaskName',
    secondTitle: 'FirstName',
    thirdTitle: 'CreatedTime',

    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/TasksDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        // userList={userList}
        config={config}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile
});

export default connect(mapStateToProps)(TaskList);